import ReactDom from "react-dom";
import "./Modal.scss";
import { ImCross } from "react-icons/im";
import React from "react";
import ReactModal from "react-modal";

if (process.env.NODE_ENV !== 'test') ReactModal.setAppElement("#root");
const customStyles = {
  overlay: {
    zIndex: 10,
  },
  content: {
    position: "fixed",
    inset: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "rgb(255, 255, 255,0.7)",
    transition: "all 0.2s ease",
  },
};

const Modal = ({ isShowing, close, title, onConfirm=()=>{},shouldConfirmBeDisabled=false, customClass="",displayModal=false,children }) => {
  const handleConfirm=()=>{
    onConfirm();
    close();
  }
  return (
    <ReactModal isOpen={isShowing} contentLabel="Modal" style={customStyles}>
      <div className={`modalContainer ${customClass}`}>
        <div className="modal">
          <header className="modal_header">
            <h2 className="modal_header-title">{title}</h2>
            <button className="close" onClick={() => close()}>
              <ImCross></ImCross>
            </button>
          </header>
          <main className="modal_content">{children}</main>
         {!displayModal &&  <footer className="modal_footer">
            <button className="submit" onClick={handleConfirm} disabled={shouldConfirmBeDisabled}>Confirm</button>
            <button className="modal-close" onClick={() => close()}>
              Cancel
            </button>
          </footer>}
        </div>
      </div>
    </ReactModal>
  );
};

export default Modal;
